

import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { AppBar, Typography, Stack, Toolbar } from '@mui/material';
import { useState, useEffect } from 'react';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { selectAuth, login, logout } from '../authNew/authSlice';
import AppDrawer from './AppDrawer';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { BaseLayoutContainer, BasePageContainer } from "../../common/viewBaseComponents";
import { Toast } from 'primereact/toast';
import { appToastRef } from './toastService';

// Renders the authenticated layout shell with toast host and routed content.
export function Layout() {
    const user = useSelector(selectAuth);
    const navigate = useNavigate();
    const location = useLocation();

    const getCurrentTitle = () => {
        switch (location.pathname) {
            case "/firebase":
                return "To-Do";
            case "/config":
                return "Impostazioni"
            default:
                return "";
            case "/favorites":
                return "Preferiti";
        }
    };

    return (
        <BaseLayoutContainer>
            <Toast ref={appToastRef} />
            {user.isLogged && <TopAppBar />}
            <Outlet />
        </BaseLayoutContainer>
    );



    // Renders the top app bar with menu trigger, title, and profile avatar.
    function TopAppBar() {
        return <div className="p-2 flex justify-content-between surface-0">
            <AppDrawer navigate={navigate} /> 
            <span className="font-medium text-800 zoominleft ">{getCurrentTitle()}</span>
            <Avatar image={user.photoURL} size="large" shape="circle" onClick={() => navigate("/config")} />
        </div>;
    }
}
